import * as React from 'react';
import {useCallback, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import {useStoreSystem} from "../../../store";
import shallow from 'zustand/shallow';
import {AuthModalBody} from "./components/AuthModalBody/AuthModalBody";
import {SaveModalBody} from "./components/SaveModalBody/SaveModalBody";
import {useSaveProject} from "../../../hooks/useSaveProject";
import {useCurrentSearchParam} from "../../../utils/hooks/useCurrentSearchParam";
import {SaveAsModalBody} from "./components/SaveAsModalBody/SaveAsModalBody";


export function SaveAndAuthProjectModal() {
    const {saveProjectModalIsOpen,currentProjectUserId, userId, setSaveProjectModal, modalBody} = useStoreSystem(state => ({
        saveProjectModalIsOpen: state.saveProjectModal.isOpen,
        modalBody: state.saveProjectModal.modalBody,
        setSaveProjectModal: state.setSaveProjectModal,
        currentProjectUserId: state.currentProjectUserId,
        userId: state.userId
    }), shallow);
    const [hash] = useCurrentSearchParam('hash')

    const saveProject = useSaveProject()

    const handleSaveWithAuth = useCallback(() => {
        setSaveProjectModal(true, 'auth')
    }, [setSaveProjectModal])

    const handleSaveProject = useCallback(async (isRewriteProject?: boolean) => {
        if (isRewriteProject && hash) {
            setSaveProjectModal(true, 'saveAs')
            return;
        }
        if ((!hash && !isRewriteProject) || (userId !== 0 && currentProjectUserId !== userId) || (currentProjectUserId && currentProjectUserId !== userId)) {
            await saveProject({ isNewProject: true })
            setSaveProjectModal(false)
        } else {
            setSaveProjectModal(true, 'saveAs')
        }
    }, [currentProjectUserId, hash, saveProject, setSaveProjectModal, userId]);

    const handleClose = useCallback(() => {
        setSaveProjectModal(false)
    }, [setSaveProjectModal])

    const backToSaveBodyModalHandler = useCallback(() => {
        setSaveProjectModal(true, 'save')
    }, [setSaveProjectModal])

    return (
        <Dialog
            maxWidth={'sm'}
            fullWidth
            open={saveProjectModalIsOpen}
            onClose={modalBody !== 'auth' ? handleClose : backToSaveBodyModalHandler}
        >
            {modalBody === 'save' && <SaveModalBody handleSaveProjectWithoutAuth={handleSaveProject} handleSaveWithAuth={handleSaveWithAuth} />}
            {modalBody === 'saveAs' && <SaveAsModalBody handleAfterSaveProject={handleClose}/>}
            {modalBody === 'auth' && <AuthModalBody handleSaveProjectWithAuth={handleSaveProject} handleBackButton={backToSaveBodyModalHandler}/>}
        </Dialog>
    );
}
